export const BASE_URL = "https://api.syshpp.com/api";
// export const BASE_URL = "http://localhost:8000/api";
export const FRONT_END_URL = 'https://www.syshpp.com';